const CREDIT_BUREAU_COLLECTION_KEYS = [
  "credit_bureau",
  "credit_bureaus",
  "creditBureau",
  "creditBureaus",
  "credit_report",
  "credit_reports",
  "creditReport",
  "creditReports",
  "credit_bureau_history",
  "credit_bureau_reports",
  "creditBureauHistory",
  "creditBureauReports",
];

const hasCreditBureauMarker = (obj) =>
  obj.requested_date != null ||
  obj.request_date != null ||
  obj.requestedDate != null ||
  obj.RequestedDate != null ||
  obj.equifax != null ||
  obj.equifax_score != null ||
  obj.Equifax != null ||
  obj.transunion != null ||
  obj.transunion_score != null ||
  obj.Transunion != null ||
  obj.experian != null ||
  obj.experian_score != null ||
  obj.Experian != null ||
  obj.requested_by != null ||
  obj.requested_by_id != null ||
  obj.RequestedBy != null ||
  obj.requested_user != null;

export const isCreditBureauRecord = (value) => {
  if (!value || typeof value !== "object" || Array.isArray(value)) return false;
  return hasCreditBureauMarker(value);
};

export const normalizeCreditBureauRecord = (raw) => {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return null;

  const attrs = raw.attributes ?? raw.data ?? raw;
  if (!attrs || typeof attrs !== "object" || Array.isArray(attrs)) return null;

  const record = {
    requested_date:
      attrs.requested_date ??
      attrs.request_date ??
      attrs.requestedDate ??
      attrs.RequestedDate ??
      attrs.requested_at,
    request_date:
      attrs.request_date ??
      attrs.requested_date ??
      attrs.requestedDate ??
      attrs.RequestedDate,
    status: attrs.status ?? attrs.Status,
    requested_by:
      attrs.requested_by ??
      attrs.requested_by_id ??
      attrs.RequestedBy ??
      attrs.requested_user,
    requested_by_id: attrs.requested_by_id ?? attrs.requested_by ?? attrs.RequestedBy,
    requested_user: attrs.requested_user ?? attrs.requested_by_user,
    equifax: attrs.equifax ?? attrs.equifax_score ?? attrs.Equifax,
    equifax_score: attrs.equifax_score ?? attrs.equifax ?? attrs.Equifax,
    transunion: attrs.transunion ?? attrs.transunion_score ?? attrs.Transunion,
    transunion_score: attrs.transunion_score ?? attrs.transunion ?? attrs.Transunion,
    experian: attrs.experian ?? attrs.experian_score ?? attrs.Experian,
    experian_score: attrs.experian_score ?? attrs.experian ?? attrs.Experian,
  };

  return isCreditBureauRecord(record) ? record : null;
};

const normalizeCreditBureauValue = (value) => {
  if (value == null) return [];

  if (Array.isArray(value)) {
    return value.map(normalizeCreditBureauRecord).filter(Boolean);
  }

  if (typeof value !== "object") return [];

  if (Array.isArray(value.data)) {
    return value.data.map(normalizeCreditBureauRecord).filter(Boolean);
  }

  if (value.data && typeof value.data === "object") {
    const fromNested = normalizeCreditBureauValue(value.data);
    if (fromNested.length) return fromNested;
  }

  if (value.attributes && typeof value.attributes === "object") {
    const fromAttrs = normalizeCreditBureauValue(value.attributes);
    if (fromAttrs.length) return fromAttrs;
  }

  const record = normalizeCreditBureauRecord(value);
  return record ? [record] : [];
};

/**
 * Resolves credit bureau records from customer detail payloads across API shapes.
 */
export const extractCreditBureauFromCustomer = (customer) => {
  if (!customer) return [];

  if (Array.isArray(customer)) {
    return customer.map(normalizeCreditBureauRecord).filter(Boolean);
  }

  if (typeof customer !== "object") return [];

  for (const key of CREDIT_BUREAU_COLLECTION_KEYS) {
    const entries = normalizeCreditBureauValue(customer[key]);
    if (entries.length) return entries;
  }

  if (Array.isArray(customer.results)) {
    const entries = customer.results.map(normalizeCreditBureauRecord).filter(Boolean);
    if (entries.length) return entries;
  }

  if (Array.isArray(customer.data)) {
    const entries = customer.data.map(normalizeCreditBureauRecord).filter(Boolean);
    if (entries.length) return entries;
  }

  const rootRecord = normalizeCreditBureauRecord(customer);
  return rootRecord ? [rootRecord] : [];
};
